const components = require.context("../Components", true, /[\w-]+\.vue$/);

const registerComponents = app => {
  components.keys().forEach(item => {
    var file = components(item);
    app.component("base-" + file.default.name, file.default);
  });
};

import ViewFile from "./ViewFile/ViewFile.vue";
import ViewFileWapper from "./ViewFileWapper/ViewFileWapper.vue";
import banner from "./banner/banner.vue";
import nextMune from "./nextMune/nextMune.vue";

export { ViewFile, ViewFileWapper ,banner};
export default registerComponents;
